/**
 * The UI layer's front door.
 *
 * House rule: everything outside `components/ui` imports from `@/components/ui`
 * and never from a file inside it. Files *within* this folder still import each
 * other directly — routing them through here would be a cycle.
 */

export { Alert, alertVariants } from './alert';
export { Badge, badgeVariants } from './badge';
export { Button, buttonVariants } from './button';
export {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  cardVariants,
} from './card';
export { Combobox } from './combobox';
export {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from './dialog';
export {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './dropdown-menu';
export { EmptyState, LoadingAnnouncement, Skeleton, Spinner } from './feedback';
export { Field, FieldGroup, FieldRow } from './field';
export { fieldControlVariants, Input } from './input';
export { Label } from './label';
export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from './select';
export { Separator } from './separator';
export { Toaster } from './sonner';
export { Tabs, TabsContent, TabsList, TabsTrigger, tabsListVariants } from './tabs';
export { Textarea } from './textarea';
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';
